import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ISendAgendasPayload {
    participants?: any
    companies?: any
    meetingDate?: string
    status?: string[]
    meetingType?: string[]
    sagaCB: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const sendAgendasSlice = createSlice({
    name: 'reporting/send-agendas',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ISendAgendasPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const sendAgendasActions = sendAgendasSlice.actions
export default sendAgendasSlice.reducer
